import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import ProjectsTitle from '../components/ProjectsTitle';
import Project from '../components/Project';
import Footer from '../components/Footer';
import Introduction from '../components/Introduction';
import Hills from '../components/Hills';
import Sun from '../components/Sun';
import { startTime } from '../index';
import '../styles/parallax.scss';
import '../styles/main.scss';
import projects from './resources/projects'

export default class ProjectsContainer extends Component {

  render() {
    console.log(projects)
    const projectEntries = projects.map((project, index) => {
      return <Project key={index} project={project} />;
    });
    // we can use ES6's object destructuring to effectively 'unpack' our props
        // <Header personalInfo={personalInfo} />
    return (
          <div className="projects-container parallax__layer--base">
            {/* notice that we then pass those unpacked props into the Counter component */}
              {projectEntries}
            <Footer />
          </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectsContainer.js